import React, { useRef } from "react";
import "./Testimonials.css";
import next_icon from "../../assets/edusity/next-icon.png";
import back_icon from "../../assets/edusity/back-icon.png";
import user_1 from "../../assets/edusity/user-1.png";
import user_2 from "../../assets/edusity/user-2.png";
import user_3 from "../../assets/edusity/user-3.png";
import user_4 from "../../assets/edusity/user-4.png";

const Testimonials = () => {

    const slider = useRef();
    let tx = 0;

    const slideForward = () => {
        if(tx > -50){
            tx -= 25;
        }
        slider.current.style.transform = `translateX(${tx}%)`
    }
    const slideBackward = () => {
        if(tx < 0){
            tx += 25;
        }
        slider.current.style.transform = `translateX(${tx}%)`
    }

  return (
    <div className="testimonials">
      <img src={next_icon} alt="" className="next-btn" onClick={slideForward} />
      <img src={back_icon} alt="" className="back-btn" onClick={slideBackward} />
      <div className="slider">
        <ul ref={slider}>
            <li>
                <div className="slide">
                    <div className="user-info"> 
                        <img src={user_1} alt=""/>
                        <div>
                            <h3>
                                Kailee Crumbell
                            </h3>
                            <span>Alaska, USA</span>
                        </div>
                    </div>
                           <p>Our greatest calling is not just to gather in worship but to go out and serve, to be the hands and feet of Christ in a world that desperately needs love and grace.</p> 
                </div>
            </li>
            <li>
                <div className="slide">
                    <div className="user-info"> 
                        <img src={user_2} alt=""/>
                        <div>
                            <h3>
                                Konnor Duncan
                            </h3>
                            <span>Alaska, USA</span>
                        </div>
                    </div>
                           <p>Faith is not about everything turning out okay; faith is about being okay no matter how things turn out.</p> 
                </div>
            </li>
            <li>
                <div className="slide">
                    <div className="user-info"> 
                        <img src={user_3} alt=""/>
                        <div>
                            <h3>
                                Dianne Satterwhite
                            </h3>
                            <span>Alaska, USA</span>
                        </div>
                    </div>
                           <p>The church is not a building we go to; it’s a community we belong to. We are called to be a light in each other’s lives and in the world.</p> 
                </div>
            </li>
            <li>
                <div className="slide">
                    <div className="user-info"> 
                        <img src={user_4} alt=""/>
                        <div>
                            <h3>
                                Kooper Henry
                            </h3>
                            <span>Alaska, USA</span>
                        </div>
                    </div>
                           <p>God doesn’t call us to do everything perfectly; He calls us to trust Him and take the next step, knowing He walks with us every step of the way.</p> 
                </div>
            </li>
        </ul>
      </div>
    </div>
  );
};

export default Testimonials;
